import { Button, Container } from "@fluidattacks/design";
import { useTranslation } from "react-i18next";

import { usePermissions } from "context/authz/hooks/use-permissions";

const ActionButtons = ({
  noVulnInSubmittedState,
  openConfirmModal,
  refreshDrafts,
}: Readonly<{
  noVulnInSubmittedState: boolean;
  openConfirmModal: VoidFunction;
  refreshDrafts: () => Promise<void>;
}>): JSX.Element => {
  const { t } = useTranslation();
  const { someGroupPermissions } = usePermissions();

  return (
    <Container alignItems={"center"} display={"flex"} gap={0.5} scroll={"none"}>
      <Button
        icon={"refresh"}
        id={"refresh-drafts"}
        onClick={refreshDrafts}
        variant={"ghost"}
      >
        {t("todoList.refresh")}
      </Button>
      {someGroupPermissions.canMutate("confirm_vulnerabilities") && (
        <Button
          disabled={noVulnInSubmittedState}
          icon={"check"}
          id={"start-review"}
          onClick={openConfirmModal}
          tooltip={t("searchFindings.tabDescription.validateLocations.tooltip")}
          variant={"ghost"}
        >
          {t("searchFindings.tabDescription.validateLocations.text")}
        </Button>
      )}
    </Container>
  );
};

export { ActionButtons };
